import { orderConstants } from '../_constants';
import { orderService } from '../_services';
import { alertActions } from '.';
import { history } from '../_helpers';

export const orderActions = {
    getById,
    update,
    updateAvailability,
    delete: _delete,
    getHistory,
    getNext,
    getAllNext,
    getCurrent,
    getAllCurrent,
};

function getById(id) {
    return (dispatch) => {
        dispatch(request());

        orderService.getById(id)
            .then(
                order => dispatch(success(order)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: orderConstants.GETDETAIL_REQUEST };
    }
    function success(order) {
        return { type: orderConstants.GETDETAIL_SUCCESS, order };
    }
    function failure(error) {
        return { type: orderConstants.GETDETAIL_FAILURE, error };
    }
}

function update(order) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        orderService.update(order)
            .then(
                (order) => {
                    dispatch(success(order));
                    resolve(order);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: orderConstants.UPDATE_REQUEST };
    }
    function success(order) {
        return { type: orderConstants.UPDATE_SUCCESS, order };
    }
    function failure(error) {
        return { type: orderConstants.UPDATE_FAILURE, error };
    }
}

function updateAvailability(orderId, availability) {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        orderService.updateAvailability(orderId, availability)
            .then(
                (order) => {
                    dispatch(success(order));
                    resolve(order);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: orderConstants.UPDATEAVAILABILITY_REQUEST };
    }
    function success(order) {
        return { type: orderConstants.UPDATEAVAILABILITY_SUCCESS, order };
    }
    function failure(error) {
        return { type: orderConstants.UPDATEAVAILABILITY_FAILURE, error };
    }
}

function getHistory() {
    return (dispatch) => {
        dispatch(request());

        orderService.getHistory()
            .then(
                orderHistory => dispatch(success(orderHistory)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: orderConstants.GETHISTORY_REQUEST };
    }
    function success(orderHistory) {
        return { type: orderConstants.GETHISTORY_SUCCESS, orderHistory };
    }
    function failure(error) {
        return { type: orderConstants.GETHISTORY_FAILURE, error };
    }
}

function getNext() {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        orderService.getNext()
            .then(
                (nextOrder) => {
                    dispatch(success(nextOrder));
                    resolve(nextOrder);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: orderConstants.GETNEXT_REQUEST };
    }
    function success(nextOrder) {
        return { type: orderConstants.GETNEXT_SUCCESS, nextOrder };
    }
    function failure(error) {
        return { type: orderConstants.GETNEXT_FAILURE, error };
    }
}

function getAllNext() {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        orderService.getAllNext()
            .then(
                (nextOrders) => {
                    dispatch(success(nextOrders));
                    resolve(nextOrders);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: orderConstants.GETALLNEXT_REQUEST };
    }
    function success(nextOrders) {
        return { type: orderConstants.GETALLNEXT_SUCCESS, nextOrders };
    }
    function failure(error) {
        return { type: orderConstants.GETALLNEXT_FAILURE, error };
    }
}

function getCurrent() {
    return (dispatch) => {
        dispatch(request());

        orderService.getCurrent()
            .then(
                currentOrder => dispatch(success(currentOrder)),
                error => dispatch(failure(error.toString())),
            );
    };

    function request() {
        return { type: orderConstants.GETCURRENT_REQUEST };
    }
    function success(currentOrder) {
        return { type: orderConstants.GETCURRENT_SUCCESS, currentOrder };
    }
    function failure(error) {
        return { type: orderConstants.GETCURRENT_FAILURE, error };
    }
}

function getAllCurrent() {
    return dispatch => new Promise((resolve, reject) => {
        dispatch(request());

        orderService.getAllCurrent()
            .then(
                (currentOrders) => {
                    dispatch(success(currentOrders));
                    resolve(currentOrders);
                },
                (error) => {
                    dispatch(failure(error.toString()));
                    reject(error);
                },
            );
    });
    function request() {
        return { type: orderConstants.GETALLCURRENT_REQUEST };
    }
    function success(currentOrders) {
        return { type: orderConstants.GETALLCURRENT_SUCCESS, currentOrders };
    }
    function failure(error) {
        return { type: orderConstants.GETALLCURRENT_FAILURE, error };
    }
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
    return (dispatch) => {
        dispatch(request(id));

        orderService.delete(id)
            .then(
                order => dispatch(success(id)),
                error => dispatch(failure(id, error.toString())),
            );
    };

    function request(id) {
        return { type: orderConstants.DELETE_REQUEST, id };
    }
    function success(id) {
        return { type: orderConstants.DELETE_SUCCESS, id };
    }
    function failure(id, error) {
        return { type: orderConstants.DELETE_FAILURE, id, error };
    }
}



// WEBPACK FOOTER //
// ./src/_actions/order.actions.js